import { OperationReference } from "../../../ExpressionsModule/Models/DomainServices/OperationReference";

/** Resolve only capabilities explicitly granted to this host; the API still receives the GUID. */
export function resolveReactOperation(operations: readonly OperationReference[] | undefined, reference: string, component: string): OperationReference {
  const matches = (operations ?? []).filter(operation =>
    operation.Id.toLowerCase() === reference.toLowerCase() ||
    (!!operation.ContextName && !!operation.Name && `${operation.ContextName}.${operation.Name}` === reference)
  );
  const distinctIds = new Set(matches.map(operation => operation.Id.toLowerCase()));
  if (distinctIds.size > 1) {
    throw new Error(`React component '${component}' requested ambiguous operation '${reference}'. Use an operation GUID.`);
  }
  if (!matches.length) {
    throw new Error(`React component '${component}' requested operation '${reference}', which is not allowed on this host. Use an allowed GUID or exact ContextName.OperationName.`);
  }
  return matches[0];
}
